import type {UpmPlant} from '../types'

import {useUpmPlantsContext} from './useUpmPlantsContext'

/** @deprecated Use `UseUpmPlantByUpmIdParams` with `plantUpmId` instead. */
interface UseUpmPlantWithRaiseErrorParams {
  plantId: string
  plantUpmId?: never
  shouldRaiseError?: true
}

/** @deprecated Use `UseUpmPlantByUpmIdParams` with `plantUpmId` instead. */
interface UseUpmPlantWithoutRaiseErrorParams {
  plantId: string
  plantUpmId?: never
  shouldRaiseError?: false
}

/** @deprecated Use params with `plantUpmId` instead. */
interface UseUpmPlantParams {
  plantId: string
  plantUpmId?: never
  shouldRaiseError?: boolean
}

interface UseUpmPlantByUpmIdWithRaiseErrorParams {
  plantUpmId: string
  plantId?: never
  shouldRaiseError?: true
}

interface UseUpmPlantByUpmIdWithoutRaiseErrorParams {
  plantUpmId: string
  plantId?: never
  shouldRaiseError?: false
}

interface UseUpmPlantByUpmIdParams {
  plantUpmId: string
  plantId?: never
  shouldRaiseError?: boolean
}

/** @deprecated Use `useUpmPlant({plantUpmId})` instead. */
export function useUpmPlant({plantId, shouldRaiseError}: UseUpmPlantWithRaiseErrorParams): UpmPlant
/** @deprecated Use `useUpmPlant({plantUpmId})` instead. */
export function useUpmPlant({
  plantId,
  shouldRaiseError
}: UseUpmPlantWithoutRaiseErrorParams): UpmPlant | undefined
export function useUpmPlant({
  plantUpmId,
  shouldRaiseError
}: UseUpmPlantByUpmIdWithRaiseErrorParams): UpmPlant
export function useUpmPlant({
  plantUpmId,
  shouldRaiseError
}: UseUpmPlantByUpmIdWithoutRaiseErrorParams): UpmPlant | undefined
export function useUpmPlant(
  params: UseUpmPlantParams | UseUpmPlantByUpmIdParams
): UpmPlant | undefined {
  const {shouldRaiseError = true} = params

  const plantUpmId = 'plantUpmId' in params ? params.plantUpmId : undefined
  const plantId = 'plantId' in params ? params.plantId : undefined

  if (plantId && plantUpmId) {
    throw new Error('useUpmPlant: plantId and plantUpmId are mutually exclusive')
  }

  const upmPlants = useUpmPlantsContext()

  let upmPlant: UpmPlant | undefined

  if (plantUpmId) {
    upmPlant = Object.values(upmPlants).find((p) => p.upmId === plantUpmId)
  } else if (plantId) {
    upmPlant = upmPlants[plantId] as UpmPlant | undefined
  } else {
    throw new Error('useUpmPlant: Either plantId or plantUpmId must be provided')
  }

  if (upmPlant === undefined && shouldRaiseError) {
    const identifier = plantUpmId ? `plantUpmId ${plantUpmId}` : `plant ${plantId ?? 'unknown'}`
    throw new Error(`useUpmPlant: No upm plant data found for ${identifier}`)
  }

  return upmPlant
}
